// action-button.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-small-action-button',
  template: `
    <app-base-button
      [baseClass]="mergedClass"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex justify-center w-full">
        <div class="flex flex-row items-center">
          <i class="fas fa-plus text-xl mr-3"></i>
          <span class="text-center text-lg font-bold">{{ text }}</span>
        </div>
      </div>
    </app-base-button>
  `
})
export class SmallActionButtonComponent {
  @Input() text: string = 'Action';
  @Input() disabled: boolean = false;
  @Input() customClass: string = '';
  @Output() onClick = new EventEmitter<MouseEvent>();

  get mergedClass(): string {
    return `w-40 bg-theme-primary text-theme-contrast py-3 px-6 rounded-2xl flex items-center justify-between h-14 ${this.customClass}`;
  }
}
